// components/BulkImportCustomers/BulkCustomerUploadForm.jsx
import React, { useState } from "react";
import { Box, Typography, Button as MuiButton } from "@material-ui/core";
import { CloudUpload as CloudUploadIcon } from "components/MaterialSymbol/MaterialIcons";
import Button from "components/CustomButtons/Button.js";

export default function BulkCustomerUploadForm({ onClose, onConfirm }) {
    const [file, setFile] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = () => {
        if (!file) return;
        onConfirm(file); // NO cerrar modal, modal debe mostrar loading
    };

    return (
        <>
            <Typography variant="h6" gutterBottom style={{ fontWeight: 500, marginBottom: 16 }}>
                Bulk Upload Customers
            </Typography>

            <Box mb={2}>
                <input
                    accept=".csv"
                    id="bulk-upload-customer-file"
                    type="file"
                    hidden
                    onChange={handleFileChange}
                />

                <label htmlFor="bulk-upload-customer-file">
                    <MuiButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        startIcon={<CloudUploadIcon />}
                        component="span"
                    >
                        {file ? file.name : "Select CSV File"}
                    </MuiButton>
                </label>

                <Typography
                    variant="caption"
                    color="textSecondary"
                    style={{ marginTop: 8, display: "block" }}
                >
                    Note: File must be in .csv format.
                </Typography>

                <Typography
                    variant="caption"
                    color="primary"
                    style={{
                        cursor: "pointer",
                        display: "block",
                        marginTop: 4,
                    }}
                    onClick={() => window.open("/sample-bulk-customers.csv", "_blank")}
                >
                    Click here to download sample .csv file
                </Typography>
            </Box>

            <Box mt={3} textAlign="center">
                <Button
                    type="button"
                    color="rose"
                    size="sm"
                    disabled={!file}
                    onClick={handleSubmit}
                    style={{ marginRight: 8 }}
                >
                    Proceed
                </Button>

                <Button onClick={onClose} size="sm" variant="outlined">
                    Close
                </Button>
            </Box>
        </>
    );
}
